import { connectors } from 'src/services/ConnectorDemo/data/ConnectorInventory';

export const getActiveConnectorSchema = (connectorId: string) => {
  const connector = connectors.find((table) => table.name === connectorId);
  return connector?.schemaName;
};
